<dx-popup
  [dragEnabled]="false"
  [enableBodyScroll]="false"
  [height]="'auto'"
  [showCloseButton]="false"
  [fullScreen]="appService.isSmallScreen()"
  [showTitle]="true"
  [hideOnOutsideClick]="false"
  [visible]="true"
  [width]="660"
  (onHiding)="closeDialog.emit(null);"
  [wrapperAttr]="{
    class: 'resetPasswordPopupWrapper'
  }"
  contentTemplate="popupContent"
  maxHeight="90vh"
  title="{{'RESET_PASSWORD.TITLE' | translate}}">
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button (onClick)="createRequestSent= true; closeDialog.emit(email);"
               [disabled]="!isNewFormValid || createRequestSent"
               [stylingMode]="'contained'" [type]="'default'"
               icon="save" text="{{'BUTTONS.RESET' | translate}}"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button (onClick)="closeDialog.emit(null);" [disabled]="createRequestSent" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <!-- ******************************** -->
  <!-- Popup Contents                   -->
  <!-- ******************************** -->

  <div *dxTemplate="let data of 'popupContent'">
    <div style="height: auto; overflow: hidden">
      <dx-text-box
        (onEnterKey)="checkValidationAndSave()"
        (onValueChanged)="validateEmail($event)"
        [(value)]="email"
        [label]="translate.instant('RESET_PASSWORD.EMAIL')"
        [valueChangeEvent]="'keyup'">
        <dxi-validation-rule
          message="{{'RESET_PASSWORD.EMAIL_FIELD' | translate }} {{'COMMON.IS_REQUIRED' | translate }}"
          type="required">
        </dxi-validation-rule>
        <dxi-validation-rule
          [pattern]="appService.EMAIL_PATTERN"
          message="{{'RESET_PASSWORD.EMAIL_FIELD' | translate }} {{'COMMON.IS_NOT_EMAIL' | translate }}"
          type="pattern">
        </dxi-validation-rule>
      </dx-text-box>
    </div>
  </div>
</dx-popup>
